module.exports = __webpack_public_path__ + "img/Flag_of_Romania.8ecaef5a.svg";